export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// /Users/sharvil/Desktop/fall17/adaptive/assign1/~/d3-selection/src/selection/empty.js
// module id = ../../../../d3-selection/src/selection/empty.js
// module chunks = 3